import { Amazon, Blockquote, InternalLink, Recommended } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Amazon,
  Blockquote,
  InternalLink,
  Recommended,
  React
};